import { render, staticRenderFns } from "./MailEditor.vue?vue&type=template&id=48ccddcf"
import script from "./MailEditor.vue?vue&type=script&lang=ts"
export * from "./MailEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports